<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-08-04 16:35:40
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Leave\LeaveBalance\components\newTransactions.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-08 10:30:27
-->
<template>
  <normalDialog
    :title="
      $t('label_essweb_leaveBalance_form_dialog_newLeaveTransactionTitle')
    "
    :dialog="show"
    width="800"
    @close="closeDialog"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_leaveBalance_form_dialog_leaveTypeLabel")
            }}</v-sheet>
            <v-autocomplete
              :items="leaveType"
              item-text="leave_type_name"
              item-value="uuid"
              :rules="$GetRules(['_Require_Rules'], [null])"
              dense
              :placeholder="
                $t('label_essweb_leaveBalance_form_dialog_leaveTypeLabel')
              "
              v-model="TransactionsData.leave_type_uuid"
              filled
              single-line
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-autocomplete>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_leaveBalance_form_dialog_transactionTypeLabel")
            }}</v-sheet>
            <v-autocomplete
              :items="Transactiontype"
              :disabled="!TransactionsData.leave_type_uuid"
              item-text="leave_transaction_type_name"
              item-value="uuid"
              :rules="$GetRules(['_Require_Rules'], [null])"
              dense
              :placeholder="
                $t('label_essweb_leaveBalance_form_dialog_transactionTypeLabel')
              "
              v-model="TransactionsData.transaction_type"
              filled
              single-line
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-autocomplete>
          </v-col>
          <template v-if="logic_method == 'D'">
            <v-col xs="12" sm="6" md="6" lg="6" cols="12">
              <DateTimePicker
                type="datetime"
                :defaultTime="TransactionsData.start_utc_datetime"
                :max="TransactionsData.end_utc_datetime"
                :rules="$GetRules(['_Require_Rules'], [null])"
                :label="
                  $t(
                    'label_essweb_leaveBalance_form_dialog_leaveStartTimeLabel'
                  )
                "
                @change="(time) => (TransactionsData.start_utc_datetime = time)"
              />
            </v-col>
            <v-col xs="12" sm="6" md="6" lg="6" cols="12">
              <DateTimePicker
                type="datetime"
                :defaultTime="TransactionsData.end_utc_datetime"
                :min="TransactionsData.start_utc_datetime"
                :label="
                  $t('label_essweb_leaveBalance_form_dialog_leaveEndTimeLabel')
                "
                @change="(time) => (TransactionsData.end_utc_datetime = time)"
              />
            </v-col>
            <!-- <v-col xs="12" sm="6" md="4" lg="4" cols="12">
              <v-sheet class="text--secondary">{{
                $t("label_essweb_leaveBalance_form_dialog_timeZoneLabel")
              }}</v-sheet>
              <v-select
                :items="staticZone"
                item-text="text"
                item-value="utc"
                dense
                :menu-props="{
                  offsetY: true,
                  transition: 'slide-y-transition',
                  rounded: true,
                  contentClass: 'elevation-4',
                }"
                single-line
                v-model="TransactionsData.leave_time_zone"
                :placeholder="
                  $t('label_essweb_leaveBalance_form_dialog_timeZoneLabel')
                "
                filled
              >
                <template v-slot:no-data> <noContent /> </template
              ></v-select>
            </v-col> -->
          </template>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <DateTimePicker
              type="month"
              :defaultTime="TransactionsData.leave_period"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :label="
                $t('label_essweb_leaveBalance_form_dialog_leavePeriodLabel')
              "
              @change="(time) => (TransactionsData.leave_period = time)"
            ></DateTimePicker>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveBalance_form_dialog_totalDayHourLabel")
            }}</v-sheet>
            <v-row>
              <v-col xs="12" sm="6" md="4" lg="4" cols="12">
                <v-text-field
                  dense
                  single-line
                  maxlength="11"
                  type="number"
                  :rules="
                    $GetRules(['_Number_negative', '_Length_Rules'], [null, 11])
                  "
                  filled
                  placeholder="days"
                  v-model="TransactionsData.days"
                >
                  <!-- <template v-slot:append-outer>{{
                    $t("label_essweb_system_dayLabel")
                  }}</template> -->
                </v-text-field>
              </v-col>
              <v-sheet
                class="text-subtitle-1 text-center"
                style="line-height: 65px !important"
                >{{ $t("label_essweb_system_dayLabel") }}</v-sheet
              >
              <v-col xs="12" sm="6" md="4" lg="4" cols="12">
                <v-text-field
                  dense
                  type="number"
                  single-line
                  maxlength="11"
                  :rules="
                    $GetRules(['_Number_negative', '_Length_Rules'], [null, 11])
                  "
                  filled
                  placeholder="hours"
                  v-model="TransactionsData.hours"
                >
                  <!-- <template v-slot:append-outer>{{
                    $t("label_essweb_system_hourLabel")
                  }}</template> -->
                </v-text-field>
              </v-col>
              <v-sheet
                class="text-subtitle-1 text-center"
                style="line-height: 65px !important"
                >{{ $t("label_essweb_system_hourLabel") }}</v-sheet
              >
            </v-row>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet
              class="white--text rounded-lg pa-3 subtitle-1"
              color="primary"
            >
              <span
                >{{
                  $t("label_essweb_leaveBalance_form_dialog_totalMinutesLabel")
                }}: {{ $get_thousand_num(totalMinute) }}
                {{ $t("label_essweb_system_minutesLabel") }}</span
              >
              <span></span>
            </v-sheet>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <DateTimePicker
              type="date"
              :defaultTime="TransactionsData.effective_utc_time"
              filled
              :max="TransactionsData.expired_utc_time"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :label="
                $t(
                  'label_essweb_leaveBalance_form_dialog_effectiveStartDateLabel'
                )
              "
              @change="(time) => (TransactionsData.effective_utc_time = time)"
            ></DateTimePicker>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <DateTimePicker
              type="date"
              filled
              :min="TransactionsData.effective_utc_time"
              :defaultTime="TransactionsData.expired_utc_time"
              :label="
                $t('label_essweb_leaveBalance_form_dialog_expiredDateLabel')
              "
              @change="(time) => (TransactionsData.expired_utc_time = time)"
            ></DateTimePicker>
          </v-col>
          <!-- <v-col xs="12" sm="6" md="4" lg="4" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveBalance_form_dialog_timeZoneLabel")
            }}</v-sheet>
            <v-select
              :items="staticZone"
              item-text="text"
              item-value="utc"
              dense
              :menu-props="{
                offsetY: true,
                transition: 'slide-y-transition',
                rounded: true,
                contentClass: 'elevation-4',
              }"
              single-line
              v-model="TransactionsData.time_zone"
              :placeholder="
                $t('label_essweb_leaveBalance_form_dialog_timeZoneLabel')
              "
              filled
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-select>
          </v-col> -->
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveBalance_form_dialog_remarkLabel")
            }}</v-sheet>
            <v-textarea
              rows="5"
              no-resize
              maxlength="500"
              v-model="TransactionsData.remarks"
              dense
              counter="500"
              single-line
              filled
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <CardActions newBtn @new="toNew" @cancel="closeDialog" />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
import dayjs from "dayjs";
export default {
  name: "newTrannsactions",
  props: {
    show: { default: false, type: Boolean },
    curUuid: { default: "", type: [String, Number] },
    staff_uuid: { default: "", type: [String, Number] },
  },
  computed: {
    ...mapGetters(["staticZone", "defaultUTC"]),
    totalMinute() {
      if (this.stand) {
        return (
          Number(this.TransactionsData.days) * Number(this.stand) +
          Number(this.TransactionsData.hours) * 60
        );
      } else {
        return 0;
      }
    },
    logic() {
      if (!this.myLogic) return -1;
      return this.queryKey.indexOf(
        this.myLogic["leave_transaction_type_property_master_code"].toString()
      );
      // 4，按天请假，3,按半天请假，1，30分钟，2.小时，0，15分钟
    },
  },
  data() {
    return {
      leaveType: [],
      stand: null || 0,
      logic_method: null,
      myLogic: null,
      leavePeriod: [],
      queryKey: [
        "is_allow_apply|is_apply_as_frontend_unit_as_minutes", //is_apply_as_15_minutes
        "is_allow_apply|is_apply_as_n_minutes", //is_apply_as_30_minutes
        "is_allow_apply|is_apply_as_full_hour",
        "is_allow_apply|is_apply_as_half_day",
        "is_allow_apply|is_apply_as_day",
      ],
      Transactiontype: [],
      TransactionsData: {
        leave_type_uuid: "",
        transaction_type: "",
        start_utc_datetime: "",
        start_time_time_zone: "",
        end_utc_datetime: "",
        end_time_time_zone: "",
        leave_period: "",
        days: 0,
        hours: 0,
        time_zone: "480",
        effective_utc_time: "",
        expired_utc_time: "",
        leave_start_date: "",
        leave_end_date: "",
        leave_time_zone: "480",
        remarks: "",
      },
    };
  },
  watch: {
    show(val) {
      if (!val) {
        if (this.$refs["form"]) this.$refs["form"].reset();
        this.TransactionsData.days = 0;
        this.TransactionsData.hours = 0;
        this.TransactionsData.effective_utc_time = "";
        this.TransactionsData.expired_utc_time = "";
        this.TransactionsData.time_zone = this.defaultUTC;
        this.TransactionsData.start_time_time_zone = this.defaultUTC;
        this.TransactionsData.end_time_time_zone = this.defaultUTC;
        this.TransactionsData.leave_time_zone = this.defaultUTC;
        this.TransactionsData.effective_utc_time = dayjs().format("YYYY-MM-DD"); //brain 默认当前日期
        this.TransactionsData.leave_period = dayjs().format("YYYY-MM");
      }
    },
    staff_uuid() {
      this.getStand();
    },
    "TransactionsData.leave_type_uuid": function (val) {
      this.TransactionsData.transaction_type = "";
      if (val) {
        this.TransactionsData.start_utc_datetime = "";
        this.TransactionsData.end_utc_datetime = "";
        this.TransactionsData.days = 0;
        this.TransactionsData.hours = 0;
        this.getTransactionType(val);
      }
    },
    "TransactionsData.transaction_type": function (val) {
      this.logic_method = val
        ? this.Transactiontype.find((ele) => ele.uuid === val)[
            "calculation_method"
          ]
        : "";
      if (val) {
        this.TransactionsData.start_utc_datetime = "";
        this.TransactionsData.end_utc_datetime = "";
        this.TransactionsData.days = 0;
        this.TransactionsData.hours = 0;
        this.getLogicKey(val);
      }
    },
    logic_method(val) {
      if (val == "D") {
        this.TransactionsData.start_utc_datetime = "";
        this.TransactionsData.end_utc_datetime = "";
        this.TransactionsData.days = 0;
        this.TransactionsData.hours = 0;
      }
    },
    "TransactionsData.start_utc_datetime": function (val) {
      if (val && this.TransactionsData.end_utc_datetime) {
        this.getCost();
      } else {
        this.TransactionsData.days = 0;
        this.TransactionsData.hours = 0;
      }
    },
    "TransactionsData.end_utc_datetime": function (val) {
      if (val && this.TransactionsData.start_utc_datetime) {
        this.getCost();
      } else {
        this.TransactionsData.days = 0;
        this.TransactionsData.hours = 0;
      }
    },
  },
  mounted() {
    this.TransactionsData.time_zone = this.defaultUTC;
    this.TransactionsData.start_time_time_zone = this.defaultUTC;
    this.TransactionsData.end_time_time_zone = this.defaultUTC;
    this.TransactionsData.leave_time_zone = this.defaultUTC;
    this.TransactionsData.effective_utc_time = dayjs().format("YYYY-MM-DD"); //brain 默认当前日期
    this.TransactionsData.leave_period = dayjs().format("YYYY-MM");
    this.getStand();
    this.getLeaveType();
  },
  methods: {
    closeDialog: function () {
      this.$emit("close");
    },
    getLogicKey: function (uuid) {
      const that = this;
      that.myLogic = null;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_transaction_type_property_master",
        url: "/leave/get-leave-transaction-type-propertys/",
        data: {
          leave_transaction_type_uuid: uuid,
          codes:
            "is_allow_apply|is_apply_as_full_hour,is_allow_apply|is_apply_as_half_day,is_allow_apply|is_apply_as_day,is_allow_apply|is_apply_as_frontend_unit_as_minutes,is_allow_apply|is_apply_as_n_minutes",
        },
      }).then((res) => {
        for (let key in res.data) {
          if (that.queryKey.indexOf(key.toString()) != -1) {
            if (res.data[key] && Number(res.data[key]["value"])) {
              if (!that.myLogic) that.myLogic = res.data[key]; //取第一个
            }
          }
        }
      });
    },
    getStand: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "hehe",
        url: "/other/get-standard-working-minutes/",
        data: { staff_uuid: this.staff_uuid },
      }).then((res) => {
        that.stand = res.data;
      });
    },
    getCost: function () {
      const that = this;
      let leaveTimeType = {};
      let arr = [
        "frontend_unit_as_minutes",
        "n_minutes",
        "full_hour",
        "half_day",
        "day",
      ];
      // 0,15分钟,1,30分钟,2.小时,3,按半天请假4，按天请假
      leaveTimeType["type"] = arr[this.logic];
      if (leaveTimeType["type"] == "half_day") {
        leaveTimeType["params"] = {
          startTime: this.TransactionsData.start_utc_datetime.split(" ")[1],
          endTime: this.TransactionsData.end_utc_datetime.split(" ")[1],
        };
      }

      this.$Request({
        method: "POST",
        table: "ess_lv_leave_application_record",
        url: "/leave/get-leave-cost/",
        data: {
          start_utc_datetime: this.$getTimeValue(
            this.TransactionsData.start_utc_datetime,
            "leave"
          ),
          end_utc_datetime: this.$getTimeValue(
            this.TransactionsData.end_utc_datetime,
            "leave"
          ),
          leave_type_uuid: this.TransactionsData.leave_type_uuid,
          leave_transaction_type_uuid: this.TransactionsData.transaction_type,
          leave_time_type: leaveTimeType,
        },
      }).then((res) => {
        that.TransactionsData.days = parseInt(
          Number(res.data.total_leave_minutes) /
            Number(res.data.standard_working_minutes)
        );
        that.TransactionsData.hours = parseFloat(
          (
            (Number(res.data.total_leave_minutes) %
              Number(res.data.standard_working_minutes)) /
            60
          ).toFixed(4)
        );
      });
    },
    getLeaveType: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_type",
        url: "/leave-type/get-list/",
      }).then((res) => {
        res.data.map((item) => {
          item.leave_type_name = that.$getCommonLangValue(item.leave_type_name);
        });
        that.leaveType = res.data;
      });
    },
    getTransactionType: function (val) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_transaction_type",
        url: "/leave-transaction-type/get-list/",
        data: { leave_type_uuid: val, add_support_type_filter: 1 },
      }).then((res) => {
        res.data.map((item) => {
          item.leave_transaction_type_name = that.$getCommonLangValue(
            item.leave_transaction_type_name
          );
        });
        that.Transactiontype = res.data;
      });
    },
    toNew: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      let data = {
        staff_uuid: this.curUuid,
        leave_type_uuid: this.TransactionsData.leave_type_uuid,
        leave_transaction_type_uuid: this.TransactionsData.transaction_type,
        leave_period: dayjs(this.TransactionsData.leave_period).format(
          "YYYYMM"
        ),
        number_of_day: this.TransactionsData.days,
        number_of_minutes: Number(this.TransactionsData.hours) * 60,
        total_minutes: this.totalMinute,
        effective_utc_datetime: this.$getTimeValue(
          this.TransactionsData.effective_utc_time
        ),
        effective_time_zone: this.TransactionsData.time_zone,
        expired_utc_datetime: this.$getTimeValue(
          this.TransactionsData.expired_utc_time
        ),
        expired_time_zone: this.TransactionsData.time_zone,
        remarks: this.TransactionsData.remarks,
      };
      if (this.logic_method == "D") {
        data["start_utc_datetime"] = this.$getTimeValue(
          this.TransactionsData.start_utc_datetime
        );
        data["end_utc_datetime"] = this.$getTimeValue(
          this.TransactionsData.end_utc_datetime
        );
        data["start_time_time_zone"] =
          this.TransactionsData.start_time_time_zone;
        data["end_time_time_zone"] = this.TransactionsData.start_time_time_zone;
      }
      this.$emit("onNew", data);
    },
  },
};
</script>
